export function svg_include(icon, suffix = '') {
    let url = '';

    if ('undefined' !== typeof window.CONFIG.svgIconsVersion && window.CONFIG.svgIconsVersion === 2) {
        url = window.CONFIG.themeUri + '/images/svg-icons/' + icon + '.svg';

        if ('undefined' !== typeof window.CONFIG.svgHashes[icon]) {
            url += '?hash=' + window.CONFIG.svgHashes[icon];
        }

        url += '#content';
    } else {
        url = window.CONFIG.themeUri + '/includes/svg-icons.svg#' + icon;
    }

    return '<svg><use xlink:href="' + url + '"></use></svg>';
}

export function load_json_from_element($element) {
    if ($element.length === 0) return null;

    let json = $element.text();

    return JSON.parse(json);
}

export function pluralise_word(count, suffix, plural_suffix = "s", append_suffix = true) {
    return count + (count !== 1 ? (append_suffix ? suffix : "") + plural_suffix : suffix);
}
